/**
 * Configurable task list sections (team-wide). Order in the array = display order.
 * Collapse state is per-device (localStorage), not persisted on the team.
 */

export const TASK_LIST_BUILTIN_IDS = [
  'pinned',
  'task_review',
  'personal_day',
  'team_day',
  'today_daily',
  'upcoming',
  'today_special',
  /** Optional temporary event list (task type `party`); add/remove via task list layout settings */
  'party_event',
] as const;

export type TaskListBuiltinId = (typeof TASK_LIST_BUILTIN_IDS)[number];

export interface TaskListBuiltinSection {
  kind: 'builtin';
  builtinId: TaskListBuiltinId;
  /** Optional emoji or short string shown left of the title */
  icon?: string;
  /** Overrides default section title */
  title?: string;
}

export interface TaskListCustomSection {
  kind: 'custom';
  id: string;
  title: string;
  icon?: string;
  /** Tasks with any of these tag ids appear in this section (and are removed from default sections). */
  tagIds: string[];
}

export type TaskListSectionEntry = TaskListBuiltinSection | TaskListCustomSection;

export const DEFAULT_TASK_LIST_LAYOUT: TaskListSectionEntry[] = [
  { kind: 'builtin', builtinId: 'pinned' },
  { kind: 'builtin', builtinId: 'task_review' },
  { kind: 'builtin', builtinId: 'personal_day' },
  { kind: 'builtin', builtinId: 'team_day' },
  { kind: 'builtin', builtinId: 'today_daily' },
  { kind: 'builtin', builtinId: 'upcoming' },
  { kind: 'builtin', builtinId: 'today_special' },
];
